import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const closeModals = () => {
    setIsPrivacyOpen(false);
    setIsTermsOpen(false);
  };
  return <footer className="bg-[#050810] text-dark-gray text-center py-10 px-4 border-t border-white/5 relative" data-id="element-243">
      <div className="max-w-4xl mx-auto flex flex-col items-center gap-6" data-id="element-244">
        {/* Links */}
        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm font-medium" data-id="element-245">
          <button onClick={() => setIsPrivacyOpen(true)} className="hover:text-primary transition-colors duration-200 underline-offset-4 hover:underline" data-id="element-246">
            Política de Privacidad
          </button>
          <span className="text-white/20 hidden sm:inline" data-id="element-247">|</span>
          <button onClick={() => setIsTermsOpen(true)} className="hover:text-primary transition-colors duration-200 underline-offset-4 hover:underline" data-id="element-248">
            Términos y Condiciones
          </button>
        </div>

        {/* Copyright */}
        <div className="space-y-2 text-xs sm:text-sm" data-id="element-249">
          <p className="text-white/80 font-medium" data-id="element-250">
            © 2025 - Domina los Comandos Eléctricos | Todos los derechos
            reservados
          </p>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      {isPrivacyOpen && <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={closeModals} data-id="element-251">
          <div className="bg-[#111827] border border-white/10 rounded-xl w-full max-w-lg max-h-[80vh] flex flex-col shadow-2xl animate-cascade-fade-delay-1" style={{
        animation: 'none'
      }} // Override global animation for modal pop
      onClick={e => e.stopPropagation()} data-id="element-252">
            {/* Header */}
            <div className="flex justify-between items-center p-5 border-b border-white/10 sticky top-0 bg-[#111827] rounded-t-xl z-10" data-id="element-253">
              <h2 className="text-white font-bold text-xl" data-id="element-254">
                Política de Privacidad
              </h2>
              <button onClick={closeModals} className="text-dark-gray hover:text-white transition-colors p-1 rounded-md hover:bg-white/10" aria-label="Cerrar" data-id="element-255">
                <XIcon className="w-6 h-6" data-id="element-256" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 overflow-y-auto text-left space-y-5 text-[#D1D5DB] text-sm leading-relaxed" data-id="element-257">
              <p data-id="element-258">
                En <strong data-id="element-259">Domina los Comandos Eléctricos</strong>, respetamos
                tu privacidad y estamos comprometidos con la protección de tus
                datos personales. Esta política explica cómo recopilamos, usamos
                y protegemos tu información.
              </p>

              <div data-id="element-260">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-261">
                  1. Información que recopilamos
                </h3>
                <p data-id="element-262">
                  Al realizar una compra, recopilamos tu nombre, dirección de
                  correo electrónico y datos de facturación. Los detalles de
                  pago son procesados de forma segura por pasarelas de pago de
                  terceros (como Hotmart, Stripe o PayPal) y no almacenamos los
                  datos de tu tarjeta de crédito.
                </p>
              </div>

              <div data-id="element-263">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-264">
                  2. Uso de la información
                </h3>
                <p data-id="element-265">Utilizamos tu información para:</p>
                <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-266">
                  <li data-id="element-267">Procesar tu compra y entregar el producto digital.</li>
                  <li data-id="element-268">
                    Enviarte actualizaciones, bonos y material relacionado con
                    el curso.
                  </li>
                  <li data-id="element-269">
                    Proporcionar soporte al cliente y responder a tus consultas.
                  </li>
                </ul>
              </div>

              <div data-id="element-270">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-271">
                  3. Protección de datos
                </h3>
                <p data-id="element-272">
                  Implementamos medidas de seguridad estándar de la industria
                  para proteger tu información personal contra acceso no
                  autorizado, alteración o destrucción. No vendemos, alquilamos
                  ni compartimos tus datos con terceros no afiliados con fines
                  de marketing.
                </p>
              </div>

              <div data-id="element-273">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-274">
                  4. Cookies
                </h3>
                <p data-id="element-275">
                  Nuestro sitio web utiliza cookies esenciales para garantizar
                  el correcto funcionamiento de la plataforma y cookies
                  analíticas para entender cómo interactúas con nuestro sitio,
                  lo que nos ayuda a mejorar la experiencia del usuario.
                </p>
              </div>

              <div data-id="element-276">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-277">
                  5. Derechos del usuario
                </h3>
                <p data-id="element-278">
                  Tienes derecho a solicitar el acceso, rectificación o
                  eliminación de tus datos personales en cualquier momento. Si
                  deseas dejar de recibir nuestros correos, puedes usar el
                  enlace de cancelación de suscripción incluido en cada mensaje.
                </p>
              </div>
            </div>
          </div>
        </div>}

      {/* Terms & Conditions Modal */}
      {isTermsOpen && <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4 backdrop-blur-sm" onClick={closeModals} data-id="element-279">
          <div className="bg-[#111827] border border-white/10 rounded-xl w-full max-w-lg max-h-[80vh] flex flex-col shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-280">
            {/* Header */}
            <div className="flex justify-between items-center p-5 border-b border-white/10 sticky top-0 bg-[#111827] rounded-t-xl z-10" data-id="element-281">
              <h2 className="text-white font-bold text-xl" data-id="element-282">
                Términos y Condiciones
              </h2>
              <button onClick={closeModals} className="text-dark-gray hover:text-white transition-colors p-1 rounded-md hover:bg-white/10" aria-label="Cerrar" data-id="element-283">
                <XIcon className="w-6 h-6" data-id="element-284" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 overflow-y-auto text-left space-y-5 text-[#D1D5DB] text-sm leading-relaxed" data-id="element-285">
              <p data-id="element-286">
                Al acceder y realizar una compra en{' '}
                <strong data-id="element-287">Domina los Comandos Eléctricos</strong>, aceptas los
                siguientes términos y condiciones. Por favor, léelos
                cuidadosamente.
              </p>

              <div data-id="element-288">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-289">
                  1. Aceptación
                </h3>
                <p data-id="element-290">
                  El uso de este sitio web y la adquisición de nuestros
                  productos digitales implica la aceptación total y sin reservas
                  de estos términos y condiciones.
                </p>
              </div>

              <div data-id="element-291">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-292">
                  2. Producto digital
                </h3>
                <p data-id="element-293">
                  "Domina los Comandos Eléctricos" es un producto 100% digital
                  (eBook/Guía en PDF y recursos adicionales). Tras la
                  confirmación del pago, recibirás acceso inmediato o un enlace
                  de descarga en tu correo electrónico. No se enviará ningún
                  artículo físico a tu domicilio.
                </p>
              </div>

              <div data-id="element-294">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-295">
                  3. Política de reembolso
                </h3>
                <p data-id="element-296">
                  Ofrecemos una garantía de satisfacción de 7 días. Si el
                  producto no cumple con tus expectativas, puedes solicitar un
                  reembolso completo dentro de los primeros 7 días posteriores a
                  la compra. Pasado este período, no se emitirán reembolsos bajo
                  ninguna circunstancia.
                </p>
              </div>

              <div data-id="element-297">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-298">
                  4. Propiedad intelectual
                </h3>
                <p data-id="element-299">
                  Todo el contenido, textos, diagramas, imágenes y materiales
                  incluidos en el producto están protegidos por derechos de
                  autor. Tu compra te otorga una licencia de uso personal e
                  intransferible. Queda estrictamente prohibida la reproducción,
                  distribución, modificación o reventa del material sin nuestra
                  autorización expresa por escrito.
                </p>
              </div>

              <div data-id="element-300">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-301">
                  5. Limitación de responsabilidad
                </h3>
                <p data-id="element-302">
                  El contenido de esta guía tiene fines estrictamente educativos
                  e informativos. El autor no se hace responsable por daños,
                  accidentes, lesiones o pérdidas materiales derivadas de la
                  mala aplicación de los conceptos enseñados. El trabajo con
                  electricidad es peligroso; siempre debes utilizar equipo de
                  protección y cumplir con las normativas eléctricas de tu país.
                </p>
              </div>

              <div data-id="element-303">
                <h3 className="text-white font-bold text-base mb-2" data-id="element-304">
                  6. Descargo de responsabilidad del producto
                </h3>
                <p data-id="element-305">
                  Este es un producto digital. No se enviará ningún producto
                  físico. El contenido de este programa tiene fines educativos.
                  Trabajar con electricidad conlleva riesgos; siempre respeta
                  las normativas de seguridad locales.
                </p>
              </div>
            </div>
          </div>
        </div>}
    </footer>;
}